import { useEntityUrl } from 'framework/routing';

export const LEADS_PATH = '/crm/leads';

export const useLeadUrl = () => {
  const baseUrls = useEntityUrl({
    baseLink: LEADS_PATH,
    timelinePostfix: 'activities',
  });

  const getConvertUrl = (id: string) => `${baseUrls.getSingleEntityUrl(id)}/convert`;

  return {
    ...baseUrls,
    getConvertUrl,
  };
};
